import { useState } from "react";
import { IconButton, Tooltip, Snackbar, Alert } from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useAppSelector } from "../../app/hooks";
import getWpUrl from "../../utils/getWpUrl";

// Bouton qui purge le cache REST (WP REST Cache) côté serveur pour TOUS les
// utilisateurs. À utiliser si on voit des données qui semblent obsolètes —
// par exemple un événement qui n'apparaît pas dans le calendrier alors qu'il
// existe dans sa fiche.
function ClearCacheButton() {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState<{
    message: string;
    severity: "success" | "error";
  } | null>(null);
  const account = useAppSelector((state) => state.account);

  const handleClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getWpUrl()}wp-json/dclubagenda/v1/cache/flush`,
        {
          method: "POST",
          headers: {
            Authorization:
              "Basic " + btoa(`${account.user_login}:${account.password}`),
          },
        }
      );
      if (response.ok) {
        setFeedback({
          message:
            "Cache vidé. Les données seront rafraîchies au prochain chargement.",
          severity: "success",
        });
      } else {
        setFeedback({
          message: `Erreur ${response.status}. Vérifiez vos droits ou réessayez plus tard.`,
          severity: "error",
        });
      }
    } catch (e) {
      setFeedback({
        message: `Erreur réseau : ${(e as Error).message}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Vider le cache — à cliquer si vous voyez des données qui semblent obsolètes. L'effet s'applique à tous les utilisateurs.">
        {/* span wrapper requis par MUI quand l'enfant IconButton peut être disabled */}
        <span>
          <IconButton
            onClick={handleClick}
            disabled={loading}
            size="large"
            aria-label="Vider le cache"
          >
            <CleaningServicesIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Snackbar
        open={!!feedback}
        autoHideDuration={4000}
        onClose={() => setFeedback(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setFeedback(null)}
          severity={feedback?.severity}
          sx={{ width: "100%" }}
        >
          {feedback?.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ClearCacheButton;
